// extracted by mini-css-extract-plugin
export default {"root":"CookieConsent_root__aBjD6","message":"CookieConsent_message__+TiGl h5","cookieLink":"CookieConsent_cookieLink__GN8+x","continueBtn":"CookieConsent_continueBtn__0Mqdc h5"};